import React, { useRef, useState, useEffect } from "react";
import "./AddC.css";

const ImageCropper = ({ onImageCapture }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [capturedImages, setCapturedImages] = useState([]);
  const [isCameraOn, setIsCameraOn] = useState(false);

  // Setup camera
  const setupVideo = async () => {
    try {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }

      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
      }
    } catch (err) {
      console.error("Camera error:", err);
      if (err.name === "NotReadableError") {
        alert("Camera is already in use. Close other apps or tabs using it.");
      }
    }
  };

  // Stop camera on unmount
  useEffect(() => {
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  // Capture full video frame
  const captureImage = () => {
    if (!videoRef.current) return;

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Set canvas size same as video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Draw the entire video frame on canvas
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Convert to Blob and save image
    canvas.toBlob(
      (blob) => {
        if (!blob) return;

        const imageName = `image-${new Date().toISOString()}.jpg`;
        const imageFile = new File([blob], imageName, { type: "image/jpeg" });
        const imageUrl = URL.createObjectURL(imageFile);

        // Save in local state
        setCapturedImages((prev) => [...prev, imageUrl]);

        // Pass file to parent if needed
        if (onImageCapture) {
          onImageCapture(imageFile);
        }
      },
      "image/jpeg",
      1
    );
  };

  return (
    <div>
      {!isCameraOn ? (
        <button
          onClick={() => {
            setIsCameraOn(true);
            setupVideo();
          }}
          className="upload-btno"
        >
          Open Camera
        </button>
      ) : (
        <div style={{ position: "relative", display: "inline-block" }}>
          {/* Video */}
          <video ref={videoRef} autoPlay className="video-preview" />

          {/* Save Button */}
          <button onClick={captureImage} className="upload-btns">
            Save Image
          </button>
        </div>
      )}

      {/* Hidden canvas */}
      <canvas ref={canvasRef} style={{ display: "none" }} />

      {/* Captured Images Preview */}
      {capturedImages.length > 0 && (
        <div style={{ marginTop: "20px", color: "black" }}>
          <h3 style={{ display: "flex", justifyContent: "start" }}>Saved Images</h3>

          {/* Scrollable container */}
          <div
            style={{
              display: "flex",
              overflowX: "auto",
              paddingBottom: "10px",
              gap: "15px",
              scrollbarWidth: "thin",
              scrollbarColor: "#888 #f1f1f1",
              width: "700px",
            }}
            className="custom-scrollbar"
          >
            {capturedImages.map((img, idx) => (
              <div
                key={idx}
                style={{
                  flex: "0 0 auto",
                  textAlign: "center",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  borderRadius: "10px",
                  padding: "5px",
                  background: "#fff",
                }}
              >
                <img
                  src={img}
                  alt={`capture-${idx}`}
                  style={{
                    width: "154px",
                    height: "150px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    display: "block",
                  }}
                />
              </div>
            ))}
          </div>

          {/* Custom Stylish Scrollbar */}
          <style>
            {`
              .custom-scrollbar::-webkit-scrollbar {
                height: 8px;
              }
              .custom-scrollbar::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 10px;
              }
              .custom-scrollbar::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 10px;
              }
              .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
            `}
          </style>
        </div>
      )}
    </div>
  );
};

export default ImageCropper;
